import { ImageOff, LayoutList } from "lucide-react";
import { Link } from "react-router-dom";

import { formatPersianNumber as numberFormatter } from "../../utils/persianNumber";
import SectionIcon from "./SectionIcon";

const initialTones = ["bg-secondary_1 text-secondary", "bg-primary_1 text-primary"];

const countMissingImages = (items) => items.filter((item) => !String(item?.image || "").trim()).length;

export default function MenuCategoryOverview({ menu, editPath }) {
  const categories = Array.isArray(menu?.categories) ? menu.categories : [];

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-5" aria-labelledby="menu-categories-title">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <SectionIcon icon={LayoutList} tone="green" />
          <h2 id="menu-categories-title" className="text-sm font-extrabold text-accent">دسته‌بندی‌ها</h2>
        </div>
        <Link to={editPath} state={menu} className="text-xs font-bold text-secondary hover:underline focus:outline-none focus:ring-2 focus:ring-secondary/20">
          مدیریت دسته‌ها
        </Link>
      </div>

      {categories.length === 0 ? (
        <p className="mt-3 rounded-lg bg-gray-50 p-3 text-xs leading-5 text-gray-500">
          این منو هنوز دسته‌بندی ندارد. از ویرایشگر اولین دسته را اضافه کنید.
        </p>
      ) : (
        <ul className="mt-3 divide-y divide-gray-100">
          {categories.map((category, index) => {
            const items = Array.isArray(category?.items) ? category.items : [];
            const missingImages = countMissingImages(items);
            return (
              <li key={category._id || category.name || index} className="flex items-center gap-3 py-2.5 text-sm">
                <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${initialTones[index % initialTones.length]}`} aria-hidden="true">
                  {(category.name || "؟").trim().charAt(0)}
                </span>
                <span className="min-w-0 flex-1 truncate font-medium text-accent">{category.name || "بدون نام"}</span>
                {missingImages > 0 && (
                  <span className="inline-flex shrink-0 items-center gap-1 text-[11px] text-amber-700">
                    <ImageOff size={12} aria-hidden="true" />
                    {numberFormatter(missingImages)} بدون تصویر
                  </span>
                )}
                <span className={`shrink-0 text-xs ${items.length ? "text-gray-500" : "text-gray-400"}`}>
                  {items.length ? `${numberFormatter(items.length)} آیتم` : "خالی"}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
